/* @flow */

import type { ThermostatCompressorSpeedFeature } from "./types";

export default function ThermostatCompressorSpeed(
  feature: ThermostatCompressorSpeedFeature
) {
  return {
    /* eslint-disable camelcase */
    compressor_speed: feature.compressor_speed,
    /* eslint-enable camelcase */
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/thermostat_compressor_speed.js